import api from '@/utils/api';

/**
 * Export company prices
 * @param {string} id Company id
 * @param {string} priceId Price id
 * @param {object} priceData - The price data
 * @returns {Promise}
 */
const updateCompanyPriceApi = (id, priceId, priceData) =>
  api.patch(`/company/${id}/price/${priceId}`, priceData);

export default updateCompanyPriceApi;
